import { createFileRoute } from "@tanstack/react-router";
import { CategoryQuarterlyPage } from "@/features/reports/category-quarterly-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/kategoria-kwartalna")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.kategoria-kwartalna",
			location.pathname,
		);
	},
	component: CategoryQuarterlyPage,
});
